export default __webpack_public_path__ + "static/hopelesslyCrushed-1441a54a36310513cd4949111a3a014a.svg";